/**
 * Created by Alican Köker on 2018-07-19.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsHelper} from "../../utils/FruitsHelper";

export class FruitsReelAttentionOverlayView extends BaseView {

    private _layer:ScalableLayer;
    private _mysteryAnimCont:PIXI.Container;
    private _orientation:string = Orientation.LANDSCAPE;
    private _randomFeatureAttentionEffect:TimelineSprite;

    constructor() {
        super();

        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.STICKY_SYMBOL.name);
        this._mysteryAnimCont = new PIXI.Container();
    }

    protected onResize(resizeData:IResizeData):void {

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._orientation = Orientation.PORTRAIT;
        } else {
            this._orientation = Orientation.LANDSCAPE;
        }
        this.initOverlays();
    }

    protected initAnimations():void {
        this.initOverlays();
    }

    private initOverlays():void {
        let ind = this._orientation === Orientation.PORTRAIT ? 2 : 3;
        let reelIndexes:[number, number] = FruitsHelper.translateReelIndex(ind);
        let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);
        this._randomFeatureAttentionEffect = FruitsReelAttentionOverlayView.createRandomFeatureAttentionEffect(rectPos);

        this._mysteryAnimCont.addChild(this._randomFeatureAttentionEffect);
        this._layer.addChild(this._mysteryAnimCont);
    }


    private static createRandomFeatureAttentionEffect(rectPos:number[]):TimelineSprite {
        let effect:TimelineSprite = new TimelineSprite(GameResources.getTextures("excitementFX"), 30);
        effect.blendMode = PIXI.BLEND_MODES.ADD;
        effect.stopLoop();
        effect.anchor.set(0, 0);
        effect.position.set(rectPos[0] - effect.width / 2, rectPos[1] - effect.height / 2);
        effect.visible = false;

        return effect;
    }

    public playRandomFeatureAttentionEffect():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._randomFeatureAttentionEffect.getAnimationAutoShowHide(true, true));
        return tl;
    }

}